import { render } from "./MobileNatalChart.vue?vue&type=template&id=1105a2bc&scoped=true"
import script from "./MobileNatalChart.vue?vue&type=script&lang=js"
export * from "./MobileNatalChart.vue?vue&type=script&lang=js"

import "./MobileNatalChart.vue?vue&type=style&index=0&id=1105a2bc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1105a2bc"]])

export default __exports__